import React from "react";

import { Avatar } from "@progress/kendo-react-layout";

import "./css/UserAvatar.css";

const getContrastColor = (bgColor) => {
    // Remove # if present
    const hex = bgColor.replace("#", "");

    // Convert hex to RGB
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);

    // Calculate relative luminance
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    // Return black or white based on luminance
    return luminance > 0.5 ? "#000000" : "#ffffff";
};

const OtherAvatar = ({
    className = "user-avatar-medium",
    name = "",
    color = { background: "#ff6347", text: "" },
    opacity = 1,
    image = false,
}) => {
    let separateNames = "";
    let initials = "";

    if (name) {
        separateNames = name.split(" ");
        initials =
            separateNames.length > 1
                ? `${separateNames[0][0]?.toUpperCase()}${separateNames[1][0]?.toUpperCase()}`
                : `${separateNames[0][0]?.toUpperCase()}`;
    }

    const textColor = color?.text || getContrastColor(color.background);

    return (
        <Avatar
            type={image ? "image" : "text"}
            rounded="full"
            border={false}
            style={{
                backgroundColor: color.background,
                color: textColor,
                userSelect: "none",
                opacity: opacity,
            }}
            className={className}
            title={name}
            size="medium"
        >
            {image ? <img src={image} alt={name} /> : <span title={name}>{initials}</span>}
        </Avatar>
    );
};

export default OtherAvatar;
